module.exports = __webpack_public_path__ + "img/21.582b55e.jpg";